export default "__VITE_ASSET__49453600__"